// extracted by mini-css-extract-plugin
module.exports = {"TourBox":"SidePanel_TourBox__ZSzpo","EventsHeader":"SidePanel_EventsHeader__jwIM4"};